import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Link,
  Text,
  useColorModeValue,
  SimpleGrid,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Stack,
  Alert,
  AlertIcon,
  IconButton
} from "@chakra-ui/react";
import { MdViewList, MdViewModule, MdCheckCircle, MdCancel, MdDelete, MdShoppingCart, MdOutlineError } from "react-icons/md";

// Custom components
import ItemWhitelist from "views/admin/Detected Product/components/ItemWhitelist";
import SuspiciousItem from "views/admin/Detected Product/components/SuspiciousItem";
import Card from "components/card/Card.js";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
import { useListContext } from "../../../../contexts/listContext";
import { useProductStore } from "../../../../store/useProductStore";
import Loader from "../../../../components/loader/Loader"

export default function Whitelisted(props) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { userId, whitelistedProducts, fetchProductsByStatus, isAdmin, isFetching } = props;
  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const [productsToShow, setProductsToShow] = useState(20); // Initial number of products to show
  const productsPerPage = 20; // Number of products to load per page
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [updateSeller, setUpdateSeller] = useState([]);
  const [searchedProds, setSearchedProds] = useState([]);
  const { list, checkedPlatforms, dateFilter } = useListContext();
  const [statusUpdate, setStatusUpdate] = useState(false);
  const [sortedProducts, setSortedProducts] = useState([]);

  const [successAlert, setSuccesAlert] = useState("");
  const [failureAlert, setFailureAlert] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [viewMode, setViewMode] = useState("grid")

  const { products, moveProducts, updateProducts } = useProductStore();

  const handleSuccessAlert = async (alertMessage) => {
    setSuccesAlert(alertMessage);
    setTimeout(() => {
      setSuccesAlert("");
    }, 5000);
  };
  const handleFailureAlert = async (alertMessage) => {
    setFailureAlert(alertMessage);
    setTimeout(() => {
      setFailureAlert("");
    }, 5000);
  };

  const loadMore = () => {
    setProductsToShow(productsToShow + productsPerPage);
  };
  const loadLess = () => {
    setProductsToShow(productsToShow - productsPerPage);
  };

  const handleUpdateSeller = async (product, seller_status) => {
    try {
      const existingIndex = updateSeller.findIndex(
        (item) => item.product.psm_id === product.psm_id
      );

      if (existingIndex !== -1) {
        // Product already exists, update its status
        setUpdateSeller((prev) => {
          const updatedSeller = [...prev];
          updatedSeller[existingIndex].seller_status = seller_status;
          return updatedSeller;
        });
      } else {
        // Product does not exist, add it to the list
        setUpdateSeller([...updateSeller, { product, seller_status }]);
      }
      //console.log('updateSeller', updateSeller);
    } catch (err) {
      console.error("err in handleInserSeller", err);
    }
  };

  const removeFromUpdate = async (product) => {
    setUpdateSeller(
      updateSeller.filter((item) => {
        return !(item.product.psm_id === product.psm_id);
      })
    );
    //console.log('removed from list new Update Seller:', updateSeller);
  };

  const handleSaveChanges = async () => {
    try {
      setIsLoading(true)

      //console.log(updateSeller);
      const uid = JSON.parse(localStorage.getItem("PAuser")).message.result.id;
      const response = await fetch(
        `${backendUrl}/api/sellers/updateSellerStatus/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sellers: updateSeller,
            uid: uid,
          }),
        }
      );

      const json = await response.json();

      if (response.ok) {
        setIsLoading(false)

        // alert("Status Updated");
        handleSuccessAlert("Changes Saved");
        handleFilter();
        setUpdateSeller([]);
        //console.log('Empty update seller', updateSeller)
      } else if (response.status === 400) {
        //console.log(json);
        setIsLoading(false)

        handleFailureAlert("Error saving changes");
        setStatusUpdate(true);
        alert(json.message);
      }
      setStatusUpdate(true);
    } catch (e) {
      setIsLoading(false)

      //console.log("error in handleSavechanges");
      handleFailureAlert("Error saving changes");
    }

    for (const item of updateSeller) {
      const { product, seller_status } = item;
      if (seller_status === "S") {
        const sellerProducts = products["whitelisted"].filter(
          (p) => p.seller_name === product.seller_name
        );
        await moveProducts("whitelisted", sellerProducts, "suspicious");
      } else if (seller_status === "T") {
        await moveProducts("whitelisted", product, "testPurchase");
      }
    }
  };

  const handleFilter = async () => {
    try {
      let keywordId = list.map((item) => item.id);
      let platformIds = checkedPlatforms.map((item) => item.id);
      let allProducts = products["whitelisted"];

      //console.log('all products', allProducts)
      let kfilter;
      let pfilter;
      let dateSort;
      // if (keywordNames.length !== 0) {
      kfilter = allProducts.filter((item) =>
        keywordId?.includes(item.keyword_id)
      );
      // } else {
      // kfilter = products;
      // } products
      // if (platformIds.length !== 0) {
      pfilter = kfilter.filter((item) =>
        platformIds?.includes(item.platform_id)
      );
      // } else {
      // pfilter = kfilter;
      // }
      //console.log("pfilter", pfilter)
      let startDate = new Date(dateFilter.startDate);
      let endDate = new Date(dateFilter.endDate);
      endDate.setHours(23, 59, 59, 999);

      //console.log("DATE RANGE", startDate, endDate);

      dateSort = await pfilter.filter((item) => {
        let date = new Date(item.date_detected);
        return date >= startDate && date <= endDate;
      });
      //console.log("dateSort", dateSort)

      setSearchedProds(dateSort);
      setSortedProducts(dateSort);
    } catch (err) {
      console.error("error in handleFilter", err);
    }
  };
  useEffect(() => {
    setSortedProducts(products["whitelisted"] || []);
    handleFilter();
  }, [list, checkedPlatforms, products["whitelisted"], dateFilter]);

  const handleSearch = async (text) => {
    try {
      if (text) {
        setSearchedProds(
          products["whitelisted"].filter(
            (item) =>
              item.title?.toLowerCase().includes(text?.toLowerCase()) ||
              item.keyword?.toLowerCase().includes(text?.toLowerCase()) ||
              item.seller_name?.toLowerCase().includes(text?.toLowerCase()) ||
              item.prod_code?.toLowerCase().includes(text?.toLowerCase())
          )
        );
      } else {
        setSearchedProds(products["whitelisted"]);
        handleFilter();
      }
    } catch (e) {
      console.error("error in search", e);
    }
  };

  return (
    <Box>
      {/* Main Fields */}
      {(isLoading || isFetching) && <Loader />}

      <Card p="0px" w="100%">
        <Flex justify={"space-between"} m={2}>

          <Text px="20px" pt="10px">
            Count: {sortedProducts.length}
          </Text>
          <Flex gap={2}>
            <IconButton size="md" icon={<MdViewList />} isActive={viewMode === 'list'} onClick={() => setViewMode('list')} />
            <IconButton size="md" icon={<MdViewModule />} isActive={viewMode === 'grid'} onClick={() => setViewMode('grid')} />

          </Flex>
        </Flex>

        <Flex
          align={{ sm: "flex-start", lg: "center" }}
          justify="space-between"
          w="100%"
          px="22px"
          py="18px"
        >
          <SearchBar
            m="10px"
            borderRadius="30px"
            onChange={(e) => handleSearch(e.target.value)}
          />
          {isAdmin && (
            <Button
              variant="action"
              alignSelf="right"
              onClick={() => handleSaveChanges()}
            >
              Save Changes
            </Button>
          )}
        </Flex>
        <SimpleGrid columns={viewMode === 'grid' ? { base: 1, md: 3, xl: 4 } : 1} spacing={3}>

          {searchedProds?.slice(0, productsToShow).map((prod, index) => {
            return (
              <ItemWhitelist
                key={index}
                index={index}
                product={prod}
                handleUpdateSeller={handleUpdateSeller}
                removeFromUpdate={removeFromUpdate}
                statusUpdate={statusUpdate}
                setStatusUpdate={setStatusUpdate}
                isAdmin={isAdmin}
                viewMode={viewMode}
              />

            );
          })}
        </SimpleGrid>
      </Card>

      <Stack spacing={3} position="fixed" right="10px" bottom="2vh">
        {successAlert !== "" && (
          <Alert status="success" variant="left-accent" w="40vw">
            <AlertIcon />
            {successAlert}
          </Alert>
        )}
        {failureAlert !== "" && (
          <Alert status="error" variant="left-accent" w="40vw">
            <AlertIcon />
            {failureAlert}
          </Alert>
        )}
      </Stack>

      <Link>
        <Text
          color={textColor}
          fontSize="l"
          fontWeight="500"
          onClick={() => loadLess()}
          r="0"
          position="absolute"
          right={{ base: "10%", md: "15%", sm: "30%" }}
          textDecoration="underline"
        >
          Show less...
        </Text>
      </Link>
      <Link>
        <Text
          color={textColor}
          fontSize="l"
          fontWeight="500"
          onClick={() => loadMore()}
          r="0"
          position="absolute"
          right={{ base: "2%", md: "5%" }}
          textDecoration="underline"
        >
          Show more...
        </Text>
      </Link>
      {/* Delete Product */}
    </Box>
  );
}
